import React, { ReactElement } from 'react';
import { Text, VideoPlayer } from '@shootsta/common-react';
import Testimonial from './Testimonial/index';

import './styles/_testimonials-block.scss';

interface ITestimonial {
  logoUrl: string;
  text: string;
  thumbnailUrl?: string;
  videoUrl?: string;
  joinDate: string;
}

interface TestimonialsBlockProps {
  title: string;
  description: string;
  hypeReelUrl: string;
  testimonials: ITestimonial[];
  brandingColor: string;
}

const TestimonialsBlock = ({
  title,
  description,
  hypeReelUrl,
  testimonials,
  brandingColor
}: TestimonialsBlockProps): ReactElement => (
  <section className="testimonials-block">
    <div className="testimonials-block__intro">
      <Text heading5 centered>{title}</Text>
      <Text heading2 centered>{description}</Text>
      <div className="testimonials-block__player">
        <VideoPlayer videoUrl={hypeReelUrl} brandingColor={brandingColor} />
      </div>
    </div>
    {testimonials && testimonials.length ? (
      <div className="testimonials-block__testimonials">
        {testimonials.map(({
          logoUrl,
          text,
          thumbnailUrl,
          videoUrl,
          joinDate
        }) => (
          <Testimonial
            key={logoUrl}
            text={text}
            logoUrl={logoUrl}
            thumbnailUrl={thumbnailUrl}
            videoUrl={videoUrl}
            joinDate={joinDate}
            brandingColor={brandingColor}
          />
        ))}
      </div>
    ) : null}
  </section>
);

export default TestimonialsBlock;
